import { IFormInstance } from '@/components';
import { IOrderDetails } from '@/models/orders.model';
import { getProductsFormValues } from './getProductsFormValues';
import { OrderDetailsFormFieldsNames } from './types';

export const syncOrderProductsFormValues = (form: IFormInstance, order: IOrderDetails | null): void => {
  const values = getProductsFormValues(order);

  if (!values) {
    return;
  }

  const nextProducts = values[OrderDetailsFormFieldsNames.PRODUCTS];
  const currentProducts = (form.getFieldValue(OrderDetailsFormFieldsNames.PRODUCTS) || {}) as Record<string, number>;

  // Ant Design merges nested objects — explicitly clear removed product ids.
  const productsToSet: Record<string, number | undefined> = { ...nextProducts };
  Object.keys(currentProducts).forEach((productId) => {
    if (!(productId in nextProducts)) {
      productsToSet[productId] = undefined;
    }
  });

  form.setFieldsValue({
    [OrderDetailsFormFieldsNames.PRODUCTS]: productsToSet,
  });
};

export const resetOrderCommentFormValues = (form: IFormInstance, order: IOrderDetails | null): void => {
  const values = getProductsFormValues(order);

  if (!values) {
    return;
  }

  form.setFieldsValue({
    [OrderDetailsFormFieldsNames.COMMENTS]: values[OrderDetailsFormFieldsNames.COMMENTS],
  });
};
